import { AvisoSiscred } from './AvisoSiscred';
import type { AbaDeConfiguracao } from './BarraDeAbas';

/**
 * As configurações do Créditos ICMS Recorrente, na Central de Configurações.
 *
 * Por ora uma aba só: o disparo do aviso de SISCRED, que antes era um item de
 * menu próprio. As próximas (parametrização do cálculo ou do cronograma)
 * entram como abas aqui, não como itens de menu.
 */
export function abasDoRecorrente(): AbaDeConfiguracao[] {
  return [{ id: 'siscred', rotulo: 'Aviso SISCRED', conteudo: <AvisoSiscred /> }];
}
